import { createFileRoute } from '@tanstack/react-router';
import DemoPage from '../components/pages/DemoPage';

/** Internal dev hub: portal shortcuts (not linked from production home). */
export const Route = createFileRoute('/demo')({
  component: DemoPage,
});
